import React from 'react';
import styles from './CurrencySelector.module.css';
import { Currency } from '../../types';
import { useCurrency } from '../../contexts/CurrencyContext';
import clsx from 'clsx';

const currencyOptions = [
  { value: Currency.USD, label: 'USD', symbol: '$' },
  { value: Currency.EUR, label: 'EUR', symbol: '€' },
  { value: Currency.KZT, label: 'KZT', symbol: '₸' },
  { value: Currency.RUB, label: 'RUB', symbol: '₽' }
];

export const CurrencySelector: React.FC = () => {
  const { selectedCurrency, setSelectedCurrency } = useCurrency();

  return (
    <div className={styles.currency_selector}>
      <span className={styles.label}>Currency:</span>
      <div className={styles.options}>
        {currencyOptions.map((option) => (
          <button
            key={option.value}
            className={clsx(
              styles.option,
              selectedCurrency === option.value && styles.selected
            )}
            onClick={() => setSelectedCurrency(option.value)}
          >
            {option.symbol} {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
